/**
 * Full-page Privacy Policy. Linked from the global footer so it's reachable
 * from any page. Uses the same `PrivacyPolicyBody` component the modal uses,
 * keeping the two surfaces in lock-step (single source of truth in
 * /app/frontend/src/lib/privacyPolicyContent.jsx).
 */
import { PrivacyPolicyBody } from "../lib/privacyPolicyContent";

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-[#FAF9F7]" data-testid="privacy-policy-page">
      <div className="max-w-3xl mx-auto px-6 py-12 md:py-20">
        <div className="bg-white p-6 md:p-12">
          <PrivacyPolicyBody />
        </div>
      </div>
    </div>
  );
}
